import React, { useEffect } from "react";
import Incomingcalls from "./Incomingcalls";
import NewIncomingCalls from "./NewIncomingCalls";
import OutgoingCalls from "./OutgoingCalls";
import NewOutgoingCalls from "./NewOutgoingCalls";
// import MissedCalls from "./MissedCalls";
import NewMissedCalls from "./NewMissedCalls";
// import ExtToExt from "./ExtToExt";
import NewExtToExt from "./NewExtToExt";
import { useAuth } from "../../Context/AuthProvider";
import UserInboundReport from "./UserInboundReport";
import UserOutboundReport from "./UserOutboundReport";
import VoiceMail from "./VoiceMail";
import UserExtensionReport from "./UserExtensionReport";
import { checkPermissions } from "../../Utils/PermissionFunctions";
// import Feedback from "./Feedback";
import NewFeedback from "./NewFeedback";
import OrderConfirmationStatus from "./OrderConfirmationStatus";
import SuperAdminExtensionsDetails from "./SuperAdminExtension";
// import MissCalled from "./MissCalled";
// import OutBoundingCall from "./OutBoundingCall";

const CallRecords = () => {
  const { auth } = useAuth();
  useEffect(() => {
    if (auth.role === "3") {
      if (!checkPermissions("call-records")) {
        window.location.href = "/";
      }
    }
  }, []);

  // console.log(auth.oc_status)
  // console.log(typeof(auth.oc_status))
  return (
    <>
      <div className="dashboardWrp">
        <div className="uk-container uk-container-large">
          <div className="dashboardTop">
            <div uk-grid="" className="uk-grid uk-grid-small">
              <div className="uk-width-2-3">
                <div className="dashboardIntro">
                  <h3>CALL RECORDS</h3>
                  {/* {auth.role === "2" && ( */}
                  {auth.role === "2" || auth.role === "1" && (
                    <p>
                      Use this page to view the call logs or call history,
                      including inbound, outbound, and missed calls.
                    </p>
                  )}
                </div>
              </div>
              {/* <div className="uk-width-1-3">
                <div className="dashboardIntro uk-text-right">
                  <button>EXPORT DATA</button>
                </div>
              </div> */}

              <div className="uk-width-1-1 ">
                <ul
                  className="uk-subnav callSwitcher"
                  uk-switcher="connect: .callClass"
                >
                  {(auth?.role === "1" || auth.role === "2" || auth.role === "3") && (
                    <>
                      {auth.role === "1" || auth.role === "2" || 
                      checkPermissions("incoming-calls") ? (
                        <li>
                          <a href="#">Incoming calls</a>
                        </li>
                      ) : null}
                      {auth.role === "1" ||auth.role === "2" ||
                      checkPermissions("outgoing-calls") ? (
                        <li>
                          <a href="#">Outgoing calls</a>
                        </li>
                      ) : null}
                      {auth.role === "1" ||auth.role === "2" ||
                      checkPermissions("offtime-calls") ? (
                        <li>
                          <a href="#">Offtime calls</a>
                        </li>
                      ) : null}
                      {auth.role === "1" ||auth.role === "2" ||
                      checkPermissions("ext-to-ext-calls") ? (
                        <li>
                          <a href="#">Ext. to Ext.</a>
                        </li>
                      ) : null}
                      {
                        // auth.role === "2" && auth.vpbx_id === "65e049a239dfa"
                        auth.call_initiated === "1" ? (
                          <li>
                            <a href="#">Feedback</a>
                          </li>
                        ) : null
                      }
                      {
                        auth.oc_status === "1" ? (
                          <li>
                            <a href="#">Order Confirmation</a>
                          </li>
                        ) : null
                      }
                      {
                        auth.role === "1" ? (
                          <li>
                            <a href="#">Extension Details</a>
                          </li>
                        ) : null
                      }
                      {/* {auth.role === "2" ? (
                        <li>
                          <a href="#">Unanswered Voicemail</a>
                        </li>
                      ) : null} */}
                    </>
                  )}
                  {/* {auth.role === "3" && (
                    <>
                      <li>
                        <a href="#">User InBound Report</a>
                      </li>
                      <li>
                        <a href="#">User OutBound Report</a>
                      </li>
                      <li>
                        <a href="#">Extension Report</a>
                      </li>
                    </>
                  )} */}
                </ul>
              </div>
            </div>
            <ul className="uk-switcher uk-margin callClass">
              {(auth.role === "1" || auth.role === "2" || auth.role === "3") && (
                <>
                  {auth.role === "1" || auth.role === "2" || checkPermissions("incoming-calls") ? (
                    <li>
                      {/* <Incomingcalls /> */}
                      <NewIncomingCalls />
                    </li>
                  ) : null}
                  {auth.role === "1" || auth.role === "2" || checkPermissions("outgoing-calls") ? (
                    <li>
                      {/* <OutgoingCalls /> */}
                      <NewOutgoingCalls />
                    </li>
                  ) : null}

                  {auth.role === "1" ||auth.role === "2" || checkPermissions("offtime-calls") ? (
                    <li>
                      {/* <MissedCalls /> */}
                      <NewMissedCalls />
                    </li>
                  ) : null}
                  {auth.role === "1" || auth.role === "2" || checkPermissions("ext-to-ext-calls") ? (
                    <li>
                      {/* <ExtToExt /> */}
                      <NewExtToExt />
                    </li>
                  ) : null}

                  {/* {auth.role === "2" && auth.vpbx_id === "65e049a239dfa" ? ( */}
                  {auth.call_initiated === "1" ? (
                    <li>
                      {/* <Feedback /> */}
                      <NewFeedback />
                    </li>
                  ) : null}
                  {auth.oc_status === "1" ? (
                    <li>
                      <OrderConfirmationStatus />
                    </li>
                  ) : null}
                  {auth.role === "1" ? (
                    <li>
                      <SuperAdminExtensionsDetails />
                    </li>
                  ) : null}
                  {/* {auth.role === "2" ? (
                    <li>
                      <VoiceMail />
                    </li>
                  ) : null} */}
                </>
              )}
              {/* {auth.role === "3" && (
                <>
                  <li>
                    <UserInboundReport />
                  </li>
                  <li>
                    <UserOutboundReport />
                  </li>
                  <li>
                    <UserExtensionReport/>
                  </li>
                </>
              )} */}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default CallRecords;
